// src/components/common/FetchErrorBanner.tsx
//
// Shared inline banner for a failed data fetch, with a retry action — used
// wherever a screen's own {data, loading, error} state can fail silently
// into "no data" (F-A-007, F-A-009): Llegadas de hoy, Reservas and the five
// Dirección analytics pages.
import React from 'react';
import { Alert, Button } from '@mui/material';
import { useTranslate } from 'react-admin';

export interface FetchErrorBannerProps {
  onRetry: () => void;
  sx?: object;
}

export const FetchErrorBanner: React.FC<FetchErrorBannerProps> = ({ onRetry, sx }) => {
  const translate = useTranslate();
  return (
    <Alert
      severity="error"
      variant="outlined"
      action={
        <Button color="inherit" size="small" onClick={onRetry} sx={{ textTransform: 'none', fontWeight: 600 }}>
          {translate('common.actions.retry')}
        </Button>
      }
      sx={{ mb: 2, ...sx }}
    >
      {translate('common.messages.load_error')}
    </Alert>
  );
};

export default FetchErrorBanner;
